<template>
  <div>
    <v-dialog v-model="exibir" scrollable persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="primary modal-title py-0">
          <span>Itens do {{ lote }}</span>
          <v-spacer/>
          <v-btn icon @click="fecharModal">
            <v-icon size="20" color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table :headers="colunas" :items="itensGrupo"
                      :total-items="itensGrupo.length"
                      :loading="false" hide-actions
                      no-data-text="Não há itens do grupo disponíveis"
                      class="az-table-list px-4 pt-2 pb-3">
          <template slot="items" slot-scope="props">
            <tr>
              <td>
                {{ props.item.sequencia || '-'}}
              </td>
              <td>
                {{ props.item.descricao || '-'}}
              </td>
              <td>
                {{ props.item.unidade || '-'}}
              </td>
              <td>
                {{ props.item.quantidade || '-'}}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
    name: 'ModalVerItensGrupo',
    components: {
    },
    props: {
        exibir:{
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: String,
            default: '800'
        },
        lote: {
            type: String,
            defautl: ''
        },
        itensGrupo:{
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            colunas: [
                {
                    value: 'sequencia',
                    text: 'Item',
                    align: 'left',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'descricao',
                    text: 'Descrição',
                    align: 'left',
                    width: '40%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'unidade',
                    text: 'Unidade',
                    align: 'left',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'quantidade',
                    text: 'Quantidade',
                    align: 'left',
                    width: '15%',
                    sortable: false,
                    class: 'primary--text'
                },
            ],
        }
    },
    methods: {
        fecharModal() {
            this.$emit('fecharModal')
        },
    }
}

</script>